module.exports = __webpack_public_path__ + "static/media/downImg.42e9827b.webp";